const companyLink={
    fb:'https://www.facebook.com/apurvasoftwaresolns',
    instagram:'https://www.instagram.com/apurvasoftwaresolutions/?hl=en',
    linkedIn:'https://www.linkedin.com/company/105148128/admin/dashboard/',
    twitter:'httsp://wwww.twitter.https://x.com/ApurvaSoftware',
    pinterest:'https://in.pinterest.com/apurvasoftwaresolutions/'
  }

  export {companyLink};